/* Add checked class to checked pay-type */
;
(function () {

    var $payType = $('.c-pay-type-item');
    if (!$payType.length) return false;

    $payType.each(function () {
        var $thisPayType = $(this);
        var $input = $('input[type="radio"]', $thisPayType);
        if ($input.length && $input.is(':checked')) {
            $thisPayType.addClass('is-checked');
        }

        $input.on('change', function () {
            if ($(this).is(':checked')) {
                $('.c-pay-type-item').removeClass('is-checked');
                $thisPayType.addClass('is-checked');
            }
        })
    })

})();